"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssmService = void 0;
const client_ssm_1 = require("@aws-sdk/client-ssm");
const __1 = require("..");
/**
 * A memoized instance of the AWS SSM client.
 */
exports.ssmService = (0, __1.once)(() => new client_ssm_1.SSM({ apiVersion: '2012-08-10' }));
